import { Provider } from '@angular/core';
import { ArrivalBoardDataSource } from './services/arrival-board-data-source';
import { HttpArrivalBoardDataSource } from './services/http-arrival-board-data-source.service';
import { ArrivalBoardConfigService } from './services/arrival-board-config.service';
import { HttpArrivalBoardConfigService } from './services/http-arrival-board-config.service';

/** DI wiring for the board/editor routes. Demo data comes from the backend mock (`ARRIVAL_BOARD_MOCK_DEMO`). */
export const ARRIVAL_BOARD_PROVIDERS: Provider[] = [
    { provide: ArrivalBoardDataSource, useClass: HttpArrivalBoardDataSource },
    { provide: ArrivalBoardConfigService, useClass: HttpArrivalBoardConfigService },
];
